import { SuperPacksClient } from '../types'

export const getSuperPack = (base: SuperPacksClient) => (id: string) =>
  base.requester.get(`/${id}`, { withCredentials: true })
